import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useEthnicityFilter = (talentFilter, talentFilterTags) => {
  const [values, setValues] = useState([]);

  // hydrate from existing filter
  useEffect(() => {
    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.ethnicity
    );

    if (attr) setValues(attr.list || []);
  }, []);

  useEffect(() => {
    const exists = talentFilter?.person_attributes?.some(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.ethnicity
    );

    if (!exists) {
      clearEthnicity();
    }
  }, [talentFilter]);

  const clearEthnicity = () => {
    setValues([]);
  };

  const isDisabled = !values.length;

  const buildEthnicityFilter = () => {
    if (isDisabled) return null;

    const ethnicityAttribute = {
      person_attribute_uuid: uuidMapping.ethnicity,
      contains: false,
      start_value: null,
      end_value: null,
      has_all_in_list: false,
      list: values,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.ethnicity,
      values
    );

    return { attribute: ethnicityAttribute, tags };
  };

  return {
    values,
    setValues,
    isDisabled,
    buildEthnicityFilter,
    clearEthnicity
  };
};
